// extracted by css-extract-rspack-plugin
export default {"settlementQuotaConfig":"settlementQuotaConfig-HAxEHv","rightTable":"rightTable-KwF99d","rightTableTop":"rightTableTop-cZvvf_"};